<dx-data-grid #datagrid [dataSource]="dataSource" [showBorders]="true"
  [focusedRowEnabled]="false" [focusedRowIndex]="0" [allowColumnResizing]="true"
  [columnResizingMode]="'widget'" [showColumnLines]="true" [showRowLines]="true" [rowAlternationEnabled]="true"
  [allowColumnReordering]="true" [wordWrapEnabled]="false" (onRowUpdating)="onRowUpdating($event)" (onEditorPreparing)="onEditorPreparing($event)"
  noDataText="Nessun componente associato"
  (onExporting)="onExporting($event)">

  <dxo-export [enabled]="true"></dxo-export>
  <dxo-paging [pageSize]="20"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

  <dxo-editing mode="row" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true">
    <dxo-texts confirmDeleteMessage="Sei sicuro di voler eliminare il componente?"></dxo-texts>
  </dxo-editing>

  <dxi-column type="buttons" [width]="60">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
  </dxi-column>

    <dxi-column dataField="idArticoloComponente" caption="Articolo Componente" width="300">
      <dxo-lookup [dataSource]="listArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr"></dxo-lookup>
    </dxi-column>

    <dxi-column dataField="quantita" caption="Quantità" alignment="left" width="100">
    </dxi-column>


</dx-data-grid>